import { render, staticRenderFns } from "./StudentUsage.vue?vue&type=template&id=1364058e&scoped=true"
import script from "./StudentUsage.vue?vue&type=script&lang=ts"
export * from "./StudentUsage.vue?vue&type=script&lang=ts"
import style0 from "./StudentUsage.vue?vue&type=style&index=0&id=1364058e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1364058e",
  null
  
)

export default component.exports